import { ImperativeDialog } from '@shared/components/dialogs/imperative-dialog';
import { IconListItem } from '@shared/components/IconListItem';
import Switch from '@shared/components/Switch/SwitchButton';
import CloseIcon from '@mui/icons-material/Close';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { Button, List } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';
import { VisitDetail, VisitForm } from '../../../entity';

import { useVisitDetailStatusSwitch } from './visit-detail-status-switch.hooks';

const VisitDetailStatusSwitch = (props: {
  methods: UseFormReturn<VisitForm>;
  visitDetail: VisitDetail;
}) => {
  const {
    methods,
    visitDetail: { visit, procedures, client },
  } = props;

  const {
    isSwitchOn,
    errors,
    missingStockAllowanceError,
    visitCloseDialogRef,
    onConfirm,
    handleChange,
    t,
  } = useVisitDetailStatusSwitch({ methods, visitDetail: { visit, procedures, client } });

  return (
    <>
      <Switch checked={!!isSwitchOn} onChange={handleChange} />
      <ImperativeDialog
        ref={visitCloseDialogRef}
        actions={
          <>
            {errors?.length === 0 && missingStockAllowanceError ? (
              <Button
                disabled={errors?.length !== 0}
                type="button"
                onClick={() => {
                  onConfirm();
                }}
              >
                {t('formDialog.confirmWithoutStockAllowances')}
              </Button>
            ) : null}
          </>
        }
        title={t('closeVisitDialog.closeWarningTitle')}
        dialogHelperText={t('closeVisitDialog.closeWarningText')}
      >
        {errors && (
          <List dense>
            {errors.map(error => (
              <IconListItem
                key={error}
                icon={<CloseIcon fontSize="small" color="primary" />}
                message={error}
              />
            ))}
            {missingStockAllowanceError && (
              <IconListItem
                key={missingStockAllowanceError}
                icon={<QuestionMarkIcon fontSize="small" color="primary" />}
                message={missingStockAllowanceError}
              />
            )}
          </List>
        )}
      </ImperativeDialog>
    </>
  );
};

export default VisitDetailStatusSwitch;
